import { LanguageManager } from "../../manager/LanguageManager";
/**
 * WordData.ts
 */
export class WordData {
    constructor(value) {
        this.value = value;
        this.english = this.isEnglishChar(value);
    }
    getPartWord(size) {
        let removed = this.value.substr(0, size);
        this.value = this.value.substring(size);
        return removed;
    }
    getValue() {
        return this.value;
    }
    getLength() {
        return this.value.length;
    }
    isEnglish() {
        return this.english;
    }
    isEnglishChar(value) {
        let charCode = value.charCodeAt(0);
        let lowerCase = charCode >= 97 && charCode <= 122;
        let upperCase = charCode >= 65 && charCode <= 90;
        return lowerCase || upperCase;
    }
}
/**
 * MessageData.ts
 */
export class MessageData {
    constructor(message, maxLength) {
        this.message = message;
        this.maxLength = maxLength;
        this.breakWords = LanguageManager.getInstance().isBreakWords();
        this.createMessages();
    }
    createMessages() {
        this.index = 0;
        this.messages = [];
        let words = this.getWords();
        let message = "";
        while (words.length > 0) {
            let word = words[0];
            let nextSize = message.length + word.getLength();
            if (nextSize <= this.maxLength) {
                message += word.getValue() + " ";
                words.shift();
            }
            else {
                if (this.breakWords && !word.isEnglish()) {
                    let diff = this.maxLength - message.length;
                    message += word.getPartWord(diff);
                }
                else if (message === "" && word.getLength() > this.maxLength) {
                    // Exit infinite loop by forcing a word break
                    console.warn(word.getValue() + " is too long to fit in message the bar of size " + this.maxLength);
                    message = word.getPartWord(this.maxLength);
                }
                this.messages.push(message.trim());
                message = "";
            }
        }
        if (message) {
            this.messages.push(message.trim());
        }
    }
    getWords() {
        let splitWords = this.message.split(" ");
        let words = [];
        for (let splitWord of splitWords) {
            words.push(new WordData(splitWord));
        }
        return words;
    }
    reset() {
        this.index = 0;
    }
    hasNext() {
        return this.index < this.messages.length;
    }
    next() {
        let message = this.messages[this.index];
        this.index++;
        return message;
    }
}
//# sourceMappingURL=MessageData.js.map